import { Injectable, signal } from '@angular/core';

export interface Toast {
  message: string;
  type: 'success' | 'error' | 'info';
  action?: { label: string; handler: () => void };
}

/**
 * Lightweight toast service using signals.
 * No Ionic dependency — works in vitest without mock issues.
 */
@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly current = signal<Toast | null>(null);

  private timeout: ReturnType<typeof setTimeout> | null = null;

  show(message: string, type: Toast['type'] = 'info', duration = 2000, action?: Toast['action']): void {
    this.clear();
    this.current.set({ message, type, action });
    this.timeout = setTimeout(() => this.clear(), duration);
  }

  success(message: string, duration = 2000, action?: Toast['action']): void {
    this.show(message, 'success', duration, action);
  }

  error(message: string, duration = 3000, action?: Toast['action']): void {
    this.show(message, 'error', duration, action);
  }

  clear(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.current.set(null);
  }
}
